import { motion } from "framer-motion";

function tierColor(score) {
  if (score >= 70) return "#10B981";
  if (score >= 55) return "#00F0FF";
  if (score >= 40) return "#F59E0B";
  return "#EF4444";
}

export function HealthGauge({ score = 0, tier = "" }) {
  const color = tierColor(score);
  const r = 54, c = 2 * Math.PI * r;
  const offset = c - (score / 100) * c;
  return (
    <div className="sim-card rounded-xl p-5 flex items-center gap-5" data-testid="sim-health">
      <div className="relative w-[132px] h-[132px] shrink-0">
        <svg viewBox="0 0 132 132" className="w-full h-full -rotate-90">
          <circle cx="66" cy="66" r={r} fill="none" stroke="#1c1c1f" strokeWidth="10" />
          <motion.circle
            cx="66" cy="66" r={r} fill="none" stroke={color} strokeWidth="10" strokeLinecap="round"
            strokeDasharray={c} initial={{ strokeDashoffset: c }} animate={{ strokeDashoffset: offset }}
            transition={{ duration: 1.1, ease: "easeOut" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="sim-head text-4xl font-extrabold" style={{ color }} data-testid="sim-health-score">{score}</span>
          <span className="sim-mono text-[9px] text-[#C2C5CE]">/ 100</span>
        </div>
      </div>
      <div>
        <p className="sim-mono text-[11px] text-[#D4D4D8] uppercase tracking-wider">Digital Product Health</p>
        <p className="sim-head text-2xl font-bold mt-0.5" style={{ color }}>{tier}</p>
        <p className="text-[#C2C5CE] text-xs mt-1 max-w-[180px]">Weighted composite of clarity, usability, trust, value & accessibility.</p>
      </div>
    </div>
  );
}
